import { render } from "./editProfile.vue?vue&type=template&id=4ad4a6f3"
import script from "./editProfile.vue?vue&type=script&lang=js"
export * from "./editProfile.vue?vue&type=script&lang=js"

import "./editProfile.vue?vue&type=style&index=0&id=4ad4a6f3&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__